import { useContext } from 'react';

import { UserAccountContext, type UserAccountContextType } from '../providers/UserAccountProvider';

export const useUserAccount = (): UserAccountContextType => {
  const ctx = useContext(UserAccountContext);
  // oxlint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (ctx === undefined) {
    throw new Error('useUserAccount used outside of ContextProvider!');
  } else {
    return ctx;
  }
};
